// VaultifyUK product-page-only JS enhancements — extracted from
// vaultify-theme.js (Performance Slice 2). Loaded only on templates that
// actually contain these features (main-product-v2.liquid,
// featured-product.liquid), not sitewide. See vaultify-theme.js for the
// functions that remain global because card-product.liquid (used on the
// homepage and collection pages) depends on them.

(function () {
  // Guard against duplicate evaluation: featured-product.liquid has no
  // section-level limit, so a merchant can legitimately add it to the same
  // page more than once (e.g. two spotlighted products on a custom landing
  // page). Each instance emits its own <script src="vaultify-product.js">
  // tag — the browser's HTTP cache avoids a second network fetch, but each
  // <script> element is still evaluated independently, so this file's setup
  // would otherwise run once per section instance rather than once per page.
  // Every function below assumes a single page-wide target (querySelector,
  // not querySelectorAll), so running twice isn't "more setup" — it's
  // redundant MutationObservers doing the same work, and for the gallery
  // drag-scroll specifically, a second listener bound to the same element
  // doubling up the scroll-position maths. Resets naturally on a genuine
  // full page/iframe reload, since window state resets with it.
  if (window.__vaultifyProductInitialized) return;
  window.__vaultifyProductInitialized = true;

  // ── Gallery thumbnail drag-scroll ──────────────────────────────────────────
  // Enables mouse-drag scrolling on the vertical thumbnail strip.

  function initGalleryThumbScroll() {
    const thumbs = document.querySelector('[id^="GalleryThumbnails-"]');
    if (!thumbs) return;

    let isDown = false, startY = 0, scrollTop = 0;

    thumbs.addEventListener('mousedown', e => {
      isDown    = true;
      startY    = e.pageY - thumbs.offsetTop;
      scrollTop = thumbs.scrollTop;
      thumbs.style.cursor = 'grabbing';
      e.preventDefault();
    });
    document.addEventListener('mouseup',   () => { isDown = false; if (thumbs) thumbs.style.cursor = 'grab'; });
    document.addEventListener('mousemove', e => {
      if (!isDown) return;
      e.preventDefault();
      thumbs.scrollTop = scrollTop - (e.pageY - thumbs.offsetTop - startY) * 1.2;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleryThumbScroll, { once: true });
  } else {
    initGalleryThumbScroll();
  }

  // ── Preorder visibility (Restock Rocket) ───────────────────────────────────
  // Shows or hides the purchase-context preorder container(s) based on
  // whether Restock Rocket has injected its preorder button into the DOM.
  // Two separate elements share data-purchase-state="preorder": the small
  // "Pre-Order" badge (rendered above Product Highlights) and the main box
  // with the description/checkbox/slots (rendered below Product
  // Highlights) — querySelectorAll so both stay in sync as one unit even
  // though they're no longer adjacent in the DOM.
  //
  // Scoped per <product-info> rather than a single page-wide querySelector:
  // Quick Add's live product-fragment fetch can inject a second product-info
  // onto a page that already has one (or onto a collection/search page with
  // other preorder products rendered elsewhere), so a page-wide check would
  // show the badge for a non-preorder product just because *some* other
  // product's Restock Rocket button exists anywhere in the DOM.

  function togglePreorderDetails() {
    const preorderSections = document.querySelectorAll('[data-purchase-state="preorder"]');
    if (!preorderSections.length) return;

    const productInfoRoots = new Set();
    preorderSections.forEach((section) => {
      const root = section.closest('product-info');
      if (root) productInfoRoots.add(root);
    });

    productInfoRoots.forEach((root) => {
      const preorderButton = root.querySelector('.restock-rocket-preorder-button');
      root.querySelectorAll('[data-purchase-state="preorder"]').forEach((preorderSection) => {
        if (preorderButton) {
          preorderSection.removeAttribute('hidden');
        } else {
          preorderSection.setAttribute('hidden', '');
          preorderSection.removeAttribute('open');
        }
      });
    });
  }

  // Restock Rocket ships the pre-order description card with inline
  // background/colour styles as a sane fallback default when no theme CSS
  // exists. The theme now provides full styling for it (see
  // main-product-v2.liquid), so these inline styles just fight the
  // theme's CSS — removing them lets the theme's styling win outright
  // regardless of how the app sets them (plain inline styles are already
  // beaten by the theme's !important rules, but this is a belt-and-braces
  // fix in case the app ever sets them via the CSSOM with its own
  // !important, which no external stylesheet can otherwise override).
  // Scoped to just these three known cosmetic-only elements — never the
  // countdown/progress slots, which the app may style functionally.
  function stripPreorderDescriptionInlineStyles() {
    const description = document.querySelector('.restock-rocket-preorder-description');
    if (!description) return;
    description.removeAttribute('style');
    description.querySelectorAll('.preorder-description-text, .preorder-detail-item').forEach((el) => {
      el.removeAttribute('style');
    });
  }

  function updatePreorderUI() {
    togglePreorderDetails();
    stripPreorderDescriptionInlineStyles();
  }

  document.addEventListener('DOMContentLoaded', updatePreorderUI);
  window.addEventListener('load', updatePreorderUI);

  // Scoped to each product-info root rather than document.body: the
  // purchase-context container is always server-rendered (just hidden)
  // inside <product-info id="MainProduct-*">, and Restock Rocket's
  // preorder button/content are injected as descendants of that same
  // element (see main-product-v2.liquid) — there's no evidence it ever
  // injects outside that subtree. Only created when a preorder container
  // actually exists on the page (template-1 and featured-product have none).
  // Every matching root is observed, not just the first — Quick Add's live
  // product-fragment fetch can add a second product-info to a page that
  // already has one, and each needs its own Restock Rocket button injection
  // detected independently.
  const preorderObserverRoots = new Set();
  document.querySelectorAll('[data-purchase-state="preorder"]').forEach((section) => {
    const root = section.closest('product-info');
    if (root) preorderObserverRoots.add(root);
  });
  if (preorderObserverRoots.size) {
    const preorderObserver = new MutationObserver(updatePreorderUI);
    preorderObserverRoots.forEach((root) => {
      preorderObserver.observe(root, { childList: true, subtree: true });
    });
  }

  // ── Unit price guardian ────────────────────────────────────────────────────
  // Restores the Shopify unit price (e.g. "£4.00 each") after app scripts
  // overwrite .price-item--last inside .unit-price via the variantChange event.
  // product-info.js stores the correct text in data-unit-price-text immediately
  // after the section fetch result is applied, before publish(variantChange) runs.

  function initUnitPriceGuardian() {
    const productInfo = document.querySelector('product-info[id^="MainProduct"]');
    if (!productInfo) return;

    const priceBlock = productInfo.querySelector('[id^="price-"]');
    if (!priceBlock) return;

    const initialSpan = priceBlock.querySelector('.unit-price .price-item--last');
    if (initialSpan && !productInfo.dataset.unitPriceText) {
      productInfo.dataset.unitPriceText = initialSpan.textContent.trim();
    }

    const guardian = new MutationObserver(() => {
      const expected = productInfo.dataset.unitPriceText;
      if (!expected) return;
      const span = priceBlock.querySelector('.unit-price .price-item--last');
      if (!span) return;
      if (span.textContent.trim() !== expected) {
        guardian.disconnect();
        span.textContent = expected;
        guardian.observe(priceBlock, { childList: true, subtree: true, characterData: true });
      }
    });

    guardian.observe(priceBlock, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUnitPriceGuardian, { once: true });
  } else {
    initUnitPriceGuardian();
  }

  // ── Easify option price formatting ──────────────────────────────────────────
  // Easify renders each option price wrapped in literal parentheses in the
  // text node itself, e.g. "(£3.99)" — this can't be trimmed via CSS, so a
  // MutationObserver strips it after Easify populates the widget, matching
  // the plain "£3.99" convention used by the theme's own pickers.

  function stripEasifyPriceBrackets() {
    document.querySelectorAll('.po-optionItemLabel-price').forEach((el) => {
      const stripped = el.textContent.replace(/[()]/g, '').trim();
      if (el.textContent !== stripped) el.textContent = stripped;
    });
  }

  document.addEventListener('DOMContentLoaded', stripEasifyPriceBrackets);
  window.addEventListener('load', stripEasifyPriceBrackets);

  // Watches document.body rather than just .product-app-block--options:
  // on mobile, Easify renders its option picker into a separate bottom-sheet
  // /drawer appended outside that container (confirmed — brackets were only
  // being stripped on desktop, where Easify renders inline, not on mobile,
  // where it doesn't). Still gated on the container existing at page load so
  // this never runs on templates that don't have Easify configured at all
  // (template-1 and featured-product never render one).
  const easifyContainers = document.querySelectorAll('.product-app-block--options');
  if (easifyContainers.length) {
    const easifyPriceObserver = new MutationObserver(stripEasifyPriceBrackets);
    easifyPriceObserver.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  // ── Accordion pointer-focus cleanup (Product Information group only) ───────
  // Clicking a <summary> to open/close an accordion (Description,
  // Specifications, and the other structured sections all use the same
  // .accordion/<summary> markup — see product-info-section.liquid, and are
  // all wrapped in .product-information-group — see main-product-v2.liquid /
  // main-product.liquid) leaves it focused. In at least one real browser
  // this was observed to still match :focus-visible after a plain pointer
  // click, not just keyboard navigation — CSS alone can't distinguish those
  // two cases, since both are the exact same :focus-visible state; a scoped
  // CSS-only attempt (component-vaultify-product-information.css's
  // inset-ring rule) narrowed the visual weight but couldn't remove it for
  // pointer clicks specifically without also hiding it from keyboard users.
  // This tracks the most recent input modality and blurs the summary only
  // when it was focused via pointer, leaving keyboard Tab-navigation's
  // focus-visible ring untouched. Native <details>/<summary> disclosure
  // behaviour is unaffected either way — the toggle has already happened by
  // the time this runs (native, before any of this fires); blur only clears
  // the visual focus indication, never the open/closed state, and never
  // prevents Enter/Space from toggling a keyboard-focused summary.
  //
  // Scoped to `.product-information-group .accordion summary` — the five
  // accordions this was actually observed on (Description on T2, plus
  // Specifications/What's in the Box/Important Information/Resources on
  // both templates) — not every `.accordion summary` theme-wide. The
  // storefront has other Dawn collapsible_tab accordions outside this group
  // (e.g. merchant-configured FAQ-style blocks elsewhere in the info
  // column, footer disclosures) that were never reported to have this
  // issue; narrowing to the group avoids changing their focus behaviour on
  // the strength of a problem only observed in Product Information. If the
  // same issue is later confirmed elsewhere, widen the selector at that
  // point with its own evidence, rather than pre-emptively broadening it
  // here.
  let vaultifyLastInputWasPointer = false;
  document.addEventListener('pointerdown', () => { vaultifyLastInputWasPointer = true; }, true);
  document.addEventListener('keydown', () => { vaultifyLastInputWasPointer = false; }, true);
  document.addEventListener('focusin', (event) => {
    if (vaultifyLastInputWasPointer && event.target.closest('.product-information-group .accordion summary')) {
      event.target.blur();
    }
  }, true);

  // ── Accordion open/closed state persistence, refresh only ─────────────────
  // Requested after live review: reopening Specifications, reading a note,
  // then hitting refresh reset every Product Information accordion back to
  // its server-rendered default, discarding what the customer just set up.
  // Explicitly scoped to "refresh only" per the request — a fresh navigation
  // to the page (a link click, typing the URL) should still show the
  // server-rendered defaults, only an actual reload of the same page should
  // restore what was open. The Navigation Timing API's entry `type` is
  // 'reload' specifically for that case (vs. 'navigate' for a normal link/
  // address-bar load, 'back_forward' for history navigation — deliberately
  // left alone here: the browser's own bfcache commonly restores a
  // back/forward page's live DOM, open accordions included, with no code
  // needed, and widening scope beyond what was actually asked for isn't
  // free — it's one more behaviour to keep correct across future changes).
  //
  // sessionStorage (not localStorage): scoped to the current tab's session
  // rather than persisting indefinitely across visits — closer to "restore
  // my scroll position," not "remember my preference forever."
  //
  // Same scope as the pointer-focus cleanup above and for the same reason:
  // `.product-information-group .accordion` is Description (T2) plus the
  // four structured sections on both templates — the accordions this was
  // actually requested for, not every `.accordion` theme-wide (Dawn's
  // collapsible_tab blocks elsewhere, footer disclosures). Widen with its
  // own evidence if the same request comes in for those.
  //
  // Each accordion needs a stable, unique `id` to key its stored state —
  // product-info-section.liquid's ProductInfo-{id}-{section_id} and Dawn's
  // own Details-{block.id}-{section.id} convention already provide this;
  // Description's <details> gained a matching id specifically to support
  // this feature (see main-product-v2.liquid).
  const ACCORDION_STATE_PREFIX = 'vaultify:accordion:';
  const navEntry = performance.getEntriesByType('navigation')[0];
  const isPageReload = !!navEntry && navEntry.type === 'reload';

  if (isPageReload) {
    document.querySelectorAll('.product-information-group .accordion > details[id]').forEach((details) => {
      const stored = sessionStorage.getItem(ACCORDION_STATE_PREFIX + details.id);
      if (stored === 'open') {
        details.setAttribute('open', '');
      } else if (stored === 'closed') {
        details.removeAttribute('open');
      }
      // No stored value yet (first visit this tab session) — leave the
      // server-rendered default state untouched.
    });
  }

  // A single capture-phase listener, not one per accordion: the native
  // `toggle` event on <details> does not bubble, so a bubbling delegated
  // listener on a common ancestor would never see it — capture phase
  // reaches the target regardless. This also means any accordion added to
  // the group later (a Theme Editor section reload, say) is covered for
  // free, with no re-init call needed on the save side (only the restore
  // pass above is a one-time, page-load operation).
  document.addEventListener('toggle', (event) => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement) || !details.id) return;
    if (!details.closest('.product-information-group .accordion')) return;
    sessionStorage.setItem(ACCORDION_STATE_PREFIX + details.id, details.open ? 'open' : 'closed');
  }, true);

  // Collector guides block (snippets/product-guides.liquid): a guide reason that uses {thickness} is rendered once per Card Thickness value
  // (only the selected one visible); switch to the sentence for the newly selected value whenever the variant changes.
  function initGuideThickness() {
    var block = document.querySelector('[data-product-guides]');
    if (!block || !block.querySelector('[data-thickness]')) return;
    var name = block.getAttribute('data-thickness-option');
    function selected() {
      var vs = document.querySelector('variant-selects');
      if (!vs) return null;
      // Radio pickers name their inputs "<option>-<n>", so find the option's fieldset by its legend (or data-option-name) instead.
      var group = null;
      vs.querySelectorAll('fieldset').forEach(function (f) {
        var legend = f.querySelector('legend');
        if (!group && ((legend && legend.textContent.trim() === name) || f.getAttribute('data-option-name') === name)) group = f;
      });
      var r = group && group.querySelector('input[type="radio"]:checked');
      if (r) return r.value;
      var s = vs.querySelector('select[name="options[' + name + ']"]');
      return s ? s.value : null;
    }
    function sync() {
      var value = selected();
      if (value == null) return;
      block.querySelectorAll('[data-thickness]').forEach(function (span) { span.hidden = span.getAttribute('data-thickness') !== value; });
    }
    document.addEventListener('change', function (ev) { if (ev.target && ev.target.closest && ev.target.closest('variant-selects')) sync(); });
    document.addEventListener('product-info:loaded', sync);
    sync();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGuideThickness, { once: true });
  } else {
    initGuideThickness();
  }

  // Reviews (snippets/product-reviews.liquid, product-rating.liquid): the stars line and any link to #reviews open the Reviews row and scroll to it (its
  // scroll-margin allows for the sticky header); "Write a review" / "See all reviews" reveal Judge.me's own widget (rendered hidden in the row) and, for
  // writing, press its own "write a review" link, so the form is Judge.me's official one.
  function initProductReviews() {
    var wrap = document.getElementById('reviews');
    if (!wrap) return;
    var details = wrap.querySelector('details');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function openAndScroll() {
      if (details) details.open = true;
      wrap.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }
    document.querySelectorAll('a[href="#reviews"]').forEach(function (a) {
      a.addEventListener('click', function (ev) { ev.preventDefault(); openAndScroll(); if (history.replaceState) history.replaceState(null, '', '#reviews'); });
    });
    if (window.location.hash === '#reviews') window.setTimeout(openAndScroll, 60);
    var widget = wrap.querySelector('[data-rv-judgeme]');
    function reveal(write) {
      if (!widget) return;
      widget.classList.add('is-visible');
      var tries = 0;
      (function press() {
        var link = null;
        if (write) {
          widget.querySelectorAll('button, a').forEach(function (el) { if (!link && /write a review/i.test(el.textContent)) link = el; });
        }
        if ((write && link) || (!write && widget.querySelector('[data-widget="review"], .jdgm-rev, .jdgm-review-widget')) || tries > 25) {
          if (link) link.click();
          widget.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest' });
          return;
        }
        tries += 1; window.setTimeout(press, 150); // Judge.me fills its container after its own script has loaded
      })();
    }
    var writeBtn = wrap.querySelector('[data-rv-write]');
    if (writeBtn) writeBtn.addEventListener('click', function () { reveal(true); });
    var allBtn = wrap.querySelector('[data-rv-all]');
    if (allBtn) allBtn.addEventListener('click', function () { reveal(false); allBtn.hidden = true; });
  }

  // Description clamp (sections/main-product-v2.liquid, styles in component-product-reviews.css): about 6 lines (5 on phones) with a fade and a
  // "Read full description" toggle. The full text is always in the HTML; when it already fits the clamp the clamp and the button are removed.
  function initDescriptionClamp() {
    var box = document.querySelector('[data-pd-clamp]');
    var btn = document.querySelector('[data-pd-toggle]');
    if (!box || !btn) return;
    // End the clamp on the last line of text that fits, so a paragraph break never leaves an empty band under the fade.
    function snap() {
      box.style.maxHeight = '';
      var limit = box.clientHeight;
      var top = box.getBoundingClientRect().top;
      var best = 0;
      var walker = document.createTreeWalker(box, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        if (!node.textContent.trim()) continue;
        var range = document.createRange();
        range.selectNodeContents(node);
        var rects = range.getClientRects();
        for (var i = 0; i < rects.length; i++) {
          var bottom = rects[i].bottom - top;
          if (rects[i].height > 0 && bottom <= limit + 1 && bottom > best) best = bottom;
        }
      }
      if (best > limit * 0.5) box.style.maxHeight = Math.ceil(best + 2) + 'px';
    }
    // Only clamp when it hides enough to be worth a button: a "Read full description" button and fade take about as much
    // room as two or three lines, so hiding three lines or fewer just shows the whole text (2026-11-01, found on phones,
    // where a four-line description lost two lines behind the button).
    var auto = false; // expanded by measure() because the text is short, not by the customer
    function lineHeight() {
      var els = box.querySelectorAll('p, li'); // the last one: the bold opening line has a taller line height than body text
      var el = els.length ? els[els.length - 1] : box;
      var lh = parseFloat(getComputedStyle(el).lineHeight);
      return isNaN(lh) ? 24 : lh;
    }
    function measure() {
      if (box.classList.contains('is-expanded') && !auto) return;
      box.classList.remove('is-expanded');
      box.style.maxHeight = '';
      var hidden = box.scrollHeight - box.clientHeight;
      var worth = hidden > Math.max(3 * lineHeight(), 80);
      btn.hidden = !worth;
      box.classList.toggle('pd-clamp--toggle', worth);
      if (!worth) { auto = true; box.classList.add('is-expanded'); return; } // short text: no clamp, no button
      auto = false;
      snap();
    }
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') !== 'true';
      box.classList.toggle('is-expanded', open);
      if (open) box.style.maxHeight = ''; else snap();
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.querySelector('[data-pd-label]').textContent = open ? 'Show less' : 'Read full description';
      btn.querySelector('[data-pd-chevron]').textContent = open ? '\u2303' : '\u2304';
      if (!open) box.scrollIntoView({ block: 'nearest' });
    });
    measure();
    window.addEventListener('load', measure);
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { if (auto || !box.classList.contains('is-expanded')) measure(); }, 150);
    });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
  }
  function initReadingAids() { initProductReviews(); initDescriptionClamp(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReadingAids, { once: true });
  } else {
    initReadingAids();
  }


  /* ---------------------------------------------------------------------------
     Easify add-ons fold (2026-11-01). The Easify block is wrapped in
     <details data-product-addons> (sections/main-product-v2.liquid). This:
     - opens it, and labels it "Required", when Easify renders a required field;
     - shows "N chosen" when the customer picks something other than the first
       (default) choice of a group, so a closed fold still says it holds a choice;
     - hides the fold when Easify renders nothing for this product.
     --------------------------------------------------------------------------- */
  function initProductAddons() {
    document.querySelectorAll('[data-product-addons]').forEach(function (fold) {
      if (fold.dataset.addonsBound) return;
      fold.dataset.addonsBound = '1';
      var body = fold.querySelector('.product-app-block--options');
      var meta = fold.querySelector('[data-product-addons-meta]');
      if (!body || !meta) return;

      // 'yes': Easify drew options. 'empty': Easify's root is there but holds nothing. 'pending': Easify has not run yet.
      function state() {
        if (body.querySelector('.po-productPageOptions-root, input, select, textarea, button, img')) return 'yes';
        if (body.querySelector('[data-tpo-theme]')) return 'empty';
        return 'pending';
      }
      var productId = fold.getAttribute('data-product-id');
      function remember(v) {
        try { localStorage.setItem('vaultify:addons:' + productId, v); } catch (e) {}
      }
      function required() {
        return !!body.querySelector('input[required], select[required], textarea[required], [aria-required="true"]');
      }
      // Easify draws its choice groups with checkboxes and pre-ticks a default ("No Protection"), so "chosen" means
      // ticked now but not ticked when Easify first rendered.
      var defaults = null;
      function ticked() {
        return Array.prototype.filter.call(body.querySelectorAll('input[type="checkbox"], input[type="radio"]'), function (i) { return i.checked; })
          .map(function (i) { return (i.name || i.id) + '|' + i.value; });
      }
      function chosenCount() {
        var now = ticked();
        if (!defaults) return 0;
        var n = 0;
        now.forEach(function (i) { if (defaults.indexOf(i) === -1) n++; });
        body.querySelectorAll('select').forEach(function (sel) { if (sel.selectedIndex > 0) n++; });
        return n;
      }
      // Easify briefly empties and redraws its root, so "nothing" is only believed once it has lasted a second;
      // until Easify has run at all the fold keeps its starting state (see the Liquid comment).
      var emptyTimer = null;
      function refresh() {
        var st = state();
        if (st !== 'yes') {
          if (st === 'empty' && !emptyTimer) {
            emptyTimer = setTimeout(function () {
              emptyTimer = null;
              if (state() !== 'yes') { fold.hidden = true; remember('0'); }
            }, 1000);
          }
          return;
        }
        if (emptyTimer) { clearTimeout(emptyTimer); emptyTimer = null; }
        fold.hidden = false;
        remember('1');
        if (required()) {
          fold.open = true;
          meta.textContent = 'Required';
          meta.classList.remove('product-addons__meta--chosen');
          return;
        }
        var n = chosenCount();
        meta.textContent = n > 0 ? n + ' chosen' : 'Optional';
        meta.classList.toggle('product-addons__meta--chosen', n > 0);
      }

      var timer;
      new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(refresh, 150); })
        .observe(body, { childList: true, subtree: true });
      // The defaults are whatever is ticked just before the customer first touches the add-ons (Easify has finished by then).
      function snapshot() { if (!defaults) defaults = ticked(); }
      body.addEventListener('pointerdown', snapshot, true);
      body.addEventListener('keydown', snapshot, true);
      body.addEventListener('change', refresh);
      body.addEventListener('click', function () { setTimeout(refresh, 50); });
      // If Easify never runs (blocked or failed), the fold would hold nothing: hide it 15 seconds after load.
      var giveUp = function () { setTimeout(function () { if (state() === 'pending') fold.hidden = true; }, 15000); };
      if (document.readyState === 'complete') giveUp(); else window.addEventListener('load', giveUp, { once: true });
      refresh();
    });
  }

  /* ---------------------------------------------------------------------------
     Phone sticky "Add to basket" bar (2026-11-01, snippets/product-sticky-buy.liquid).
     Shown below 750px when the real buy row is off screen (after a little
     scrolling), with the current price and button label copied from the page.
     Pressing it presses the real Add to basket button; when that button is
     disabled (sold-out option, unfinished choice) it scrolls to the buy row.
     --------------------------------------------------------------------------- */
  function initStickyBuy() {
    var bar = document.querySelector('[data-sticky-buy]');
    if (!bar || bar.dataset.bound) return;
    bar.dataset.bound = '1';
    var sid = bar.getAttribute('data-section-id');
    var info = document.getElementById('MainProduct-' + sid);
    if (!info) return;
    var priceEl = bar.querySelector('[data-sticky-buy-price]');
    var wasEl = bar.querySelector('[data-sticky-buy-was]');
    var titleEl = bar.querySelector('.sticky-buy__title');
    var titleText = titleEl ? titleEl.textContent : '';
    var saveEl = bar.querySelector('[data-sticky-buy-save]');
    var btn = bar.querySelector('[data-sticky-buy-button]');
    var mq = window.matchMedia('(max-width: 749px)');
    var rowVisible = true;
    var shown = false;

    // The buy area: the quantity + button row, or (sold-out products have no row) the product form holding "Get notified".
    function row() { return info.querySelector('.product-buy-row') || info.querySelector('product-form') || info.querySelector('.product-form__buttons'); }
    var statusEl = bar.querySelector('[data-sticky-buy-status]');
    function notifyBtn() {
      var b = info.querySelector('.restock-rocket-button-product, .restock-rocket-button');
      return b && b.offsetParent !== null ? b : null;
    }
    function realBtn() { return info.querySelector('.product-form__submit[name="add"]'); }

    function sync() {
      var price = document.getElementById('price-' + sid);
      if (price) {
        var onSale = price.querySelector('.price--on-sale');
        var el = onSale ? price.querySelector('.price__sale .price-item--sale') : price.querySelector('.price__regular .price-item--regular');
        if (el && el.textContent.trim()) priceEl.textContent = el.textContent.trim();
        // Reduced: the old price struck through and the page's own "Save X%" next to it.
        var wasSrc = onSale && price.querySelector('.price__sale s.price-item--regular');
        var saveSrc = onSale && price.querySelector('.price-item--savings');
        if (wasEl) {
          var wasText = wasSrc ? wasSrc.textContent.trim() : '';
          wasEl.hidden = !wasText;
          if (wasText) wasEl.innerHTML = '<span class="visually-hidden">Regular price</span>' + wasText.replace(/[<>&]/g, '');
        }
        if (saveEl) {
          var saveText = saveSrc && saveSrc.offsetParent !== null ? saveSrc.textContent.trim() : '';
          saveEl.hidden = !saveText;
          saveEl.textContent = saveText;
        }
      }
      var addonNote = document.getElementById('PriceAddons-' + sid);
      if (titleEl) {
        var withAddons = addonNote && !addonNote.hidden && addonNote.textContent.trim();
        titleEl.textContent = withAddons || titleText;
        titleEl.classList.toggle('sticky-buy__title--addons', !!withAddons);
      }
      var real = realBtn();
      var notify = notifyBtn();
      var mode;
      var preorder = real && real.classList.contains('restock-rocket-preorder-button');
      if (preorder) {
        // Restock Rocket pre-order: the button reads "Pre-order" and stays disabled until the terms box is ticked.
        btn.textContent = (real.querySelector('span') || real).textContent.trim() || 'Pre-order';
        mode = 'preorder';
      } else if (real && !real.disabled) {
        var label = (real.querySelector('span') || real).textContent.trim();
        btn.textContent = label || btn.textContent;
        mode = 'add';
      } else if (notify) {
        // Sold out (the product, or the chosen option): the waitlist button.
        btn.textContent = notify.textContent.trim() || 'Get notified';
        mode = 'notify';
      } else {
        btn.textContent = 'Choose options';
        mode = 'scroll';
      }
      btn.dataset.mode = mode;
      btn.classList.toggle('button--primary', mode !== 'notify');
      btn.classList.toggle('button--secondary', mode === 'notify');
      btn.classList.toggle('sticky-buy__button--notify', mode === 'notify');
      if (statusEl) statusEl.hidden = mode !== 'notify';
    }

    function setShown(on) {
      if (on === shown) return;
      shown = on;
      if (on) sync();
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      btn.tabIndex = on ? 0 : -1;
      document.body.classList.toggle('has-sticky-buy', on);
    }

    function update() {
      var r = row();
      if (!mq.matches || !r) { setShown(false); return; }
      setShown(!rowVisible && window.scrollY > 300);
    }

    function scrollToRow() {
      var r = row();
      if (!r) return;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var top = r.getBoundingClientRect().top + window.scrollY - window.innerHeight / 3;
      window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
    }

    btn.addEventListener('click', function () {
      sync();
      if (btn.dataset.mode === 'preorder') {
        var pre = realBtn();
        if (pre && !pre.disabled) { pre.click(); return; }
        // Terms not ticked yet: take the customer to the box and point it out.
        var box = info.querySelector('.restock-rocket-acknowledge-checkbox-input');
        var boxLabel = box && (box.closest('label') || info.querySelector('label[for="' + box.id + '"]') || box.parentElement);
        if (!box || !boxLabel) { scrollToRow(); return; }
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var top = boxLabel.getBoundingClientRect().top + window.scrollY - window.innerHeight / 3;
        window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
        boxLabel.classList.remove('sticky-buy-attention');
        void boxLabel.offsetWidth;
        boxLabel.classList.add('sticky-buy-attention');
        setTimeout(function () { try { box.focus({ preventScroll: true }); } catch (e) { box.focus(); } }, reduce ? 0 : 450);
        setTimeout(function () { boxLabel.classList.remove('sticky-buy-attention'); }, 2600);
        return;
      }
      if (btn.dataset.mode === 'notify') {
        var n = notifyBtn();
        if (n) n.click(); else scrollToRow();
        return;
      }
      var real = realBtn();
      if (btn.dataset.mode !== 'add' || !real) { scrollToRow(); return; }
      real.click();
      // If the add fails (Easify required field, stock limit), the error shows by the real button: bring it into view.
      setTimeout(function () {
        var err = info.querySelector('.product-form__error-message-wrapper');
        if (err && !err.hasAttribute('hidden') && err.textContent.trim()) scrollToRow();
      }, 1500);
    });

    var observed = null;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { rowVisible = e.isIntersecting; });
      update();
    });
    function observe() {
      var r = row();
      if (r && r !== observed) {
        if (observed) io.unobserve(observed);
        io.observe(r);
        observed = r;
      }
    }
    observe();

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; update(); });
    }, { passive: true });
    if (mq.addEventListener) mq.addEventListener('change', update); else if (mq.addListener) mq.addListener(update);

    document.addEventListener('vaultify:price-updated', function () { sync(); });
    // Variant changes re-render the price and button: refresh what the bar shows.
    info.addEventListener('change', function () { setTimeout(function () { observe(); if (shown) sync(); }, 700); });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(function () { observe(); if (shown) sync(); }, 50); });
    }
    update();
  }


  /* ---------------------------------------------------------------------------
     Rewards / Help dock clearance (2026-11-01). The dock is fixed bottom-right and
     used to sit over the product title, price and buy area as they scrolled past.
     While any part of the buy area (title to returns / delivery / points) is in
     the bottom band of the screen where the dock sits, body.dock-clear fades the
     dock out (CSS in component-product-buy-flow.css). The phone sticky bar hides
     it separately (has-sticky-buy).
     --------------------------------------------------------------------------- */
  function initDockClearance() {
    if (!('IntersectionObserver' in window) || !document.querySelector('.vaultify-dock')) return;
    var info = document.querySelector('product-info[id^="MainProduct"]');
    if (!info) return;
    var BAND = 120;
    var io = null;
    var inBand = new Set();
    function targets() {
      return Array.prototype.slice.call(info.querySelectorAll(
        '.product__title-row, [id^="price-"], variant-selects, .product-highlights, .product-addons, .product-buy-row, .product-buy-row__buttons, .purchase-reassurance'
      ));
    }
    function apply() { document.body.classList.toggle('dock-clear', inBand.size > 0); }
    function observe() {
      if (io) io.disconnect();
      inBand.clear();
      var top = Math.max(0, window.innerHeight - BAND);
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) inBand.add(e.target); else inBand.delete(e.target); });
        apply();
      }, { rootMargin: '-' + top + 'px 0px 0px 0px', threshold: 0 });
      targets().forEach(function (t) { io.observe(t); });
    }
    observe();
    var rt;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(observe, 150); });
    // Variant changes re-render parts of the buy area: observe the new elements.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(observe, 100); });
    }
  }


  /* ---------------------------------------------------------------------------
     Desktop "At a glance" card (2026-11-01; markup in main-product-v2.liquid,
     CSS in component-product-buy-flow.css). From 990px the Specifications and
     What's in the Box rows sit in a card beside the description. The rows stay
     open there (they are headings, not toggles), and when the card is taller
     than the description column (or the screen) it is cut with "Show all
     specifications", which lets it grow. Below 990px nothing here applies.
     --------------------------------------------------------------------------- */
  /* The "At a glance" card picks a layout on desktop (990px+) from the card's full height (N) and the left column's
     height (M), measured for each candidate in turn:
     - fit:     N <= M. Side by side, as before (sticky; cut at the screen height with "Show all" if taller than it).
     - grow:    N is at most 160px taller than M and fits the screen: side by side, and the row grows to the card.
     - wide:    the card takes half the width with the specifications in two columns (the description gets narrower,
                so taller); used when that brings N within 160px of M and on screen, and only where the row is at
                least 1150px wide (narrower halves make the two columns cramped).
     - stacked: anything taller. The description runs full width, then the card spans the full width below it
                (specifications in two or three columns, the box contents beside them), then the other rows.
     Nothing is cut in grow, wide or stacked, and the gap under a short description is never more than 160px. */
  function initFactsCard() {
    var aside = document.querySelector('[data-pi-facts]');
    if (!aside || aside.dataset.bound) return;
    aside.dataset.bound = '1';
    var group = aside.closest('.product-information-group');
    var main = group && group.querySelector('.pig-main');
    var card = aside.querySelector('[data-pi-facts-card]');
    var more = aside.querySelector('[data-pi-facts-more]');
    var mq = window.matchMedia('(min-width: 990px)');
    var rows = aside.querySelectorAll('.product-specifications__row').length;
    var busy = false;
    var mode = '';

    function keepOpen() {
      if (!mq.matches) return;
      aside.querySelectorAll('details').forEach(function (d) { if (!d.open) d.open = true; });
    }
    // The choice itself is window.vaultifyFactsLayout (inline in main-product-v2.liquid, so it first runs before paint).
    function layout() {
      if (busy || !group || !main || !window.vaultifyFactsLayout) return;
      busy = true;
      mode = window.vaultifyFactsLayout(group);
      busy = false;
      check();
    }
    function check() {
      if (!mq.matches || mode !== 'fit' || aside.classList.contains('is-expanded')) { more.hidden = true; return; }
      var clipped = card.scrollHeight > card.clientHeight + 2;
      more.hidden = !clipped;
      if (clipped) {
        var box = aside.querySelector('.product-included-contents__list');
        if (box && rows) more.textContent = 'Show all specifications and box contents';
        else if (box) more.textContent = 'Show everything in the box';
        else more.textContent = rows > 1 ? 'Show all ' + rows + ' specifications' : 'Show all';
      }
    }
    more.addEventListener('click', function () {
      aside.classList.add('is-expanded');
      more.hidden = true;
    });
    // Saved accordion state (or a stray toggle) must not close the card's rows on desktop.
    aside.addEventListener('toggle', function () { setTimeout(function () { keepOpen(); layout(); }, 0); }, true);
    keepOpen();
    layout();
    if ('ResizeObserver' in window) {
      var last = '';
      var ro = new ResizeObserver(function () {
        // Only re-decide when the content or the space really changed, not because the layout we set moved things.
        var key = Math.round(group.getBoundingClientRect().width) + ':' + card.scrollHeight + ':' + main.scrollHeight;
        if (key === last) return;
        last = key;
        layout();
      });
      ro.observe(group);
      ro.observe(card);
    }
    var rt;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { keepOpen(); layout(); }, 150); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(layout);
    window.addEventListener('load', layout);
  }


  /* ---------------------------------------------------------------------------
     Add-on prices (2026-11-01). Easify adds the chosen add-ons to the page price
     (#price-…) itself, but nothing said so, and on a reduced product it rewrites
     the struck "was" price from its own data (wrong) while "Save X%" stayed at
     its server value. This keeps them consistent:
     - "Includes £X of add-ons" under the price when the price shown is above
       the selected variant's own price;
     - on a reduced variant the struck price is its compare-at price plus the
       add-ons, and "Save X%" is worked out from the two prices shown;
     - fires 'vaultify:price-updated' so the phone sticky bar copies it.
     --------------------------------------------------------------------------- */
  function initPriceAddons() {
    var info = document.querySelector('product-info[id^="MainProduct"]');
    if (!info || !window.productData || !window.productData.variants) return;
    var sid = info.id.replace('MainProduct-', '');
    var box = document.getElementById('price-' + sid);
    var note = document.getElementById('PriceAddons-' + sid);
    if (!box || !note) return;

    function parse(t) { var n = parseFloat(String(t || '').replace(/[^0-9.]/g, '')); return isNaN(n) ? null : n; }
    function money(n) { return '£' + n.toFixed(2); }
    function variant() {
      var input = info.querySelector('form[action*="/cart/add"] input[name="id"]');
      var id = input ? Number(input.value) : null;
      var vs = window.productData.variants;
      for (var i = 0; i < vs.length; i++) if (vs[i].id === id) return vs[i];
      return null;
    }

    var mo;
    function compute() {
      var v = variant();
      var P = box.querySelector('.price');
      if (!v || !P) return;
      var base = v.price / 100;
      var cmp = v.compare_at_price ? v.compare_at_price / 100 : 0;
      var onSale = P.classList.contains('price--on-sale');
      var shownEl = onSale ? box.querySelector('.price__sale .price-item--sale') : box.querySelector('.price__regular .price-item--regular');
      var shown = shownEl ? parse(shownEl.textContent) : null;
      if (shown == null) return;
      var extra = Math.round((shown - base) * 100) / 100;
      var hasExtra = extra > 0.004;
      var noteText = hasExtra ? 'Includes ' + money(extra) + ' of add-ons' : '';
      if (note.textContent !== noteText) note.textContent = noteText;
      note.hidden = !hasExtra;

      if (onSale && cmp > base) {
        var was = Math.round((cmp + (hasExtra ? extra : 0)) * 100) / 100;
        var wasEl = box.querySelector('.price__sale s.price-item--regular');
        if (wasEl && parse(wasEl.textContent) !== was) wasEl.textContent = money(was);
        var saveEl = box.querySelector('.price-item--savings');
        if (saveEl && /\d+\s*%/.test(saveEl.textContent)) {
          var pct = Math.round(((was - shown) / was) * 100);
          var txt = saveEl.textContent.replace(/\d+\s*%/, pct + '%');
          if (txt !== saveEl.textContent) saveEl.textContent = txt;
        }
      }
      if (mo) mo.takeRecords(); // ignore our own edits
      document.dispatchEvent(new CustomEvent('vaultify:price-updated', { detail: { sectionId: sid, addons: hasExtra ? extra : 0 } }));
    }

    var t;
    function soon() { clearTimeout(t); t = setTimeout(compute, 60); }
    mo = new MutationObserver(soon);
    mo.observe(box, { childList: true, subtree: true, characterData: true });
    info.addEventListener('change', function () { setTimeout(compute, 300); });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(compute, 100); });
    }
    compute();
  }

  /* Highlights "Show N more" on phones (2026-11-01). Delegated, so it also works in a Quick add copy of the product. */
  function initHighlightsMore() {
    if (window.__vaultifyHighlightsMore) return;
    window.__vaultifyHighlightsMore = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-highlights-more]');
      if (!btn) return;
      var prev = btn.previousElementSibling;
      var list = prev && prev.classList.contains('product-highlights') ? prev : document.getElementById(btn.getAttribute('aria-controls'));
      if (!list) return;
      var open = !list.classList.contains('is-open');
      list.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? 'Show fewer' : btn.getAttribute('data-more-label');
    });
  }

  /* Title actions (2026-11-01): Share (device share sheet on touch devices, otherwise a small pop-up) and the
     confirmation note for Swish's wishlist heart. Markup: main-product-v2.liquid title block + snippets/product-share.liquid. */
  function initProductActions() {
    document.querySelectorAll('[data-product-actions]').forEach(function (actions) {
      if (actions.dataset.actionsBound) return;
      if (actions.closest('quick-add-modal')) return;
      actions.dataset.actionsBound = '1';
      var info = actions.closest('product-info');

      // Phones: beside the price instead of the title (the title keeps its full width); back beside the title at 750px+.
      var home = actions.parentNode;
      var slot = info && info.querySelector('[data-actions-phone-slot]');
      if (slot) {
        var mq = window.matchMedia('(max-width: 749px)');
        var place = function () {
          var target = mq.matches ? slot : home;
          if (actions.parentNode !== target) target.appendChild(actions);
        };
        place();
        if (mq.addEventListener) mq.addEventListener('change', place); else mq.addListener(place);
      }

      // --- Share ---
      var share = actions.querySelector('[data-product-share]');
      if (share) {
        var toggle = share.querySelector('[data-share-toggle]');
        var pop = share.querySelector('[data-share-pop]');
        var copyBtn = share.querySelector('[data-share-copy]');
        var copyLabel = share.querySelector('[data-share-copy-label]');
        var title = share.getAttribute('data-title') || document.title;
        var image = share.getAttribute('data-image') || '';
        var copyTimer;

        var shareUrl = function () {
          var url = new URL(window.location.href);
          var params = new URLSearchParams();
          var input = info && info.querySelector('form[action*="/cart/add"] input[name="id"]');
          var variant = (input && input.value) || url.searchParams.get('variant');
          var productData = window.productData;
          if (variant && !(productData && productData.variants && productData.variants.length < 2)) params.set('variant', variant);
          var q = params.toString();
          return url.origin + url.pathname + (q ? '?' + q : '');
        };

        var fill = function () {
          var u = shareUrl();
          var eu = encodeURIComponent(u);
          var et = encodeURIComponent(title);
          var hrefs = {
            whatsapp: 'https://wa.me/?text=' + encodeURIComponent(title + ' ' + u),
            facebook: 'https://www.facebook.com/sharer/sharer.php?u=' + eu,
            x: 'https://twitter.com/intent/tweet?url=' + eu + '&text=' + et,
            pinterest: 'https://www.pinterest.com/pin/create/button/?url=' + eu + '&media=' + encodeURIComponent(image) + '&description=' + et,
            email: 'mailto:?subject=' + et + '&body=' + encodeURIComponent(title + '\n' + u)
          };
          pop.querySelectorAll('[data-share-net]').forEach(function (a) {
            a.href = hrefs[a.getAttribute('data-share-net')] || '#';
          });
        };

        var outside = function (ev) { if (!share.contains(ev.target)) close(false); };
        var onKey = function (ev) { if (ev.key === 'Escape') close(true); };
        var open = function () {
          fill();
          pop.hidden = false;
          toggle.setAttribute('aria-expanded', 'true');
          document.addEventListener('click', outside, true);
          document.addEventListener('keydown', onKey);
          var first = pop.querySelector('.product-share__item');
          if (first) first.focus();
        };
        var close = function (refocus) {
          if (pop.hidden) return;
          pop.hidden = true;
          toggle.setAttribute('aria-expanded', 'false');
          document.removeEventListener('click', outside, true);
          document.removeEventListener('keydown', onKey);
          if (refocus) toggle.focus();
        };
        share.addEventListener('focusout', function (ev) {
          if (!pop.hidden && ev.relatedTarget && !share.contains(ev.relatedTarget)) close(false);
        });

        toggle.addEventListener('click', function () {
          if (!pop.hidden) { close(true); return; }
          var touch = window.matchMedia('(pointer: coarse)').matches;
          if (touch && navigator.share) {
            navigator.share({ title: title, url: shareUrl() }).catch(function () {});
            return;
          }
          open();
        });

        pop.querySelectorAll('[data-share-net]').forEach(function (a) {
          a.addEventListener('click', function () { window.setTimeout(function () { close(false); }, 0); });
        });

        copyBtn.addEventListener('click', function () {
          var u = shareUrl();
          var done = function () {
            copyLabel.textContent = 'Link copied';
            copyBtn.classList.add('is-done');
            clearTimeout(copyTimer);
            copyTimer = window.setTimeout(function () {
              copyLabel.textContent = 'Copy link';
              copyBtn.classList.remove('is-done');
            }, 2500);
          };
          var fallback = function () {
            var ta = document.createElement('textarea');
            ta.value = u;
            ta.setAttribute('readonly', '');
            ta.style.position = 'fixed';
            ta.style.opacity = '0';
            document.body.appendChild(ta);
            ta.select();
            try { document.execCommand('copy'); done(); } catch (e) { /* nothing more to try */ }
            ta.remove();
          };
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(u).then(done, fallback);
          } else {
            fallback();
          }
        });
      }

      // --- Wishlist confirmation (Swish toggles .wk-selected on its own button) ---
      var wish = actions.querySelector('[data-product-wish]');
      var note = actions.querySelector('[data-wish-note]');
      if (wish && note) {
        var userAction = 0;
        var noteTimer;
        wish.addEventListener('click', function () { userAction = Date.now(); }, true);
        var hide = function () { note.classList.remove('is-shown'); };
        var show = function (saved) {
          note.innerHTML = saved
            ? 'Saved to your wishlist<a href="/pages/wishlist">View</a>'
            : 'Removed from your wishlist';
          note.classList.add('is-shown');
          clearTimeout(noteTimer);
          noteTimer = window.setTimeout(hide, saved ? 4000 : 2500);
        };
        note.addEventListener('mouseenter', function () { clearTimeout(noteTimer); });
        note.addEventListener('mouseleave', function () { noteTimer = window.setTimeout(hide, 1500); });
        new MutationObserver(function (records) {
          if (Date.now() - userAction > 4000) return;
          records.forEach(function (r) {
            var el = r.target;
            if (!el.classList || !el.classList.contains('wk-button')) return;
            var was = (r.oldValue || '').indexOf('wk-selected') !== -1;
            var now = el.classList.contains('wk-selected');
            if (was !== now) { userAction = 0; show(now); }
          });
        }).observe(wish, { attributes: true, attributeFilter: ['class'], attributeOldValue: true, subtree: true });
      }
    });
  }

  function initBuyFlow() { initProductAddons(); initPriceAddons(); initStickyBuy(); initDockClearance(); initFactsCard(); initHighlightsMore(); initProductActions(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBuyFlow, { once: true });
  } else {
    initBuyFlow();
  }

})();
